// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textInput_xyByA {
  padding-left : 5px;
  padding-right : 5px;
  padding:5px;
  border-top-width : 0;
  border-left-width : 0;
  border-right-width : 0;
  /*border-bottom: solid 1px rgba(0,0,0,0.05);*/
  border: 1px solid var( --border-color );
  border-radius : 0;
  font-weight: 300;
  font-size:14px;
}

.textInput_xyByA:focus {
  border-color: var( --purple );
  outline-width: 0;
}

.textInput_xyByA.error_Khv73 {
    border-color: var( --red );
}



`, "",{"version":3,"sources":["webpack://./src/views/TextInput.css"],"names":[],"mappings":"AAGA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,6CAA6C;EAC7C,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["@import \"../style/theme.css\";\n\n\n.textInput {\n  padding-left : 5px;\n  padding-right : 5px;\n  padding:5px;\n  border-top-width : 0;\n  border-left-width : 0;\n  border-right-width : 0;\n  /*border-bottom: solid 1px rgba(0,0,0,0.05);*/\n  border: 1px solid var( --border-color );\n  border-radius : 0;\n  font-weight: 300;\n  font-size:14px;\n}\n\n.textInput:focus {\n  border-color: var( --purple );\n  outline-width: 0;\n}\n\n.textInput.error {\n    border-color: var( --red );\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textInput": `textInput_xyByA`,
	"error": `error_Khv73`
};
export default ___CSS_LOADER_EXPORT___;
